type IconProps = React.SVGProps<SVGSVGElement>;

const Send: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.6 12.001C21.5662 12.583 21.3035 13.0142 20.7764 13.2716C19.4012 13.9444 18.0249 14.616 16.6491 15.2877C12.4481 17.3387 8.24708 19.3902 4.04605 21.4407C3.54796 21.6839 3.10285 21.6462 2.75549 21.3254C2.38083 20.9795 2.34424 20.5461 2.46002 20.0816C2.92043 18.2317 3.38248 16.3823 3.84398 14.5324C3.91825 14.2351 3.99035 13.9373 4.0679 13.6411C4.12962 13.4055 4.25906 13.2962 4.49718 13.27C6.74406 13.0213 8.99149 12.7732 11.2384 12.5246C11.3465 12.5125 11.4552 12.5022 11.5628 12.4852C11.8228 12.4437 11.9997 12.2426 11.9986 11.9966C11.997 11.7507 11.8184 11.5458 11.5568 11.5146C10.8129 11.4272 10.068 11.3469 9.32355 11.2643C8.1526 11.1343 6.98164 11.0042 5.81123 10.8741C5.38468 10.8266 4.95868 10.7785 4.53213 10.7326C4.2525 10.7025 4.1318 10.6069 4.06299 10.332C3.52502 8.1859 2.98651 6.0398 2.45347 3.89206C2.3426 3.44393 2.38793 3.02148 2.74511 2.6832C3.07663 2.36951 3.53103 2.31103 3.97779 2.52745C5.07993 3.06192 6.17988 3.60132 7.28039 4.13853C11.7567 6.32343 16.2324 8.51052 20.7103 10.6922C21.2652 10.9627 21.5673 11.3862 21.6 12.001Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Send;
